import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { setSuperBatches, superBatchesSelector } from 'features/classCreation';
import styles from './ScheduleSuperBatchesSelect.module.scss';
import SuperBatchSelect from 'components/SuperBatchSelect';

function ScheduleSuperBatchesSelect() {
  const dispatch = useDispatch();
  const superBatches = useSelector(superBatchesSelector);
  const excludedSuperBatchIds = useMemo(
    () => superBatches.map((o) => o.value),
    [superBatches]
  );

  const handleChange = useCallback(
    (value) => {
      dispatch(setSuperBatches(value));
    },
    [dispatch]
  );

  return (
    <SuperBatchSelect
      isMulti
      containerClassName={classNames(styles.root, 'm-r-xs m-b-xs')}
      excludedSuperBatchIds={excludedSuperBatchIds}
      onChange={handleChange}
      value={superBatches}
    />
  );
}

export default ScheduleSuperBatchesSelect;
